import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";


// 🔹 Images
import p1 from "../../Assets/6th_slider/6123-nz.png";
import p2 from "../../Assets/6th_slider/6124-ts.png";
import p3 from "../../Assets/6th_slider/6125-xl.png";
import p4 from "../../Assets/6th_slider/6126-cx.png";
import p5 from "../../Assets/6th_slider/6635-ha.png";
import p6 from "../../Assets/6th_slider/6788-ae.png";
import p7 from "../../Assets/6th_slider/6126-cx.png";
import Product_slider from "./Product_slider";
 import ExclusiveStore from "./Exclusive_Store";

const images = [p1, p2, p3, p4, p5, p6, p7];

const Six_slider = () => {
    return (
        <>
            <div className="w-full bg-white py-8">
                <div className="max-w-7xl mx-auto px-4">

                    {/* 🔹 HEADER */}
                    <div className="flex items-center justify-between mb-6">
                        <div>
                            <h2 className="text-[26px] font-medium text-black">
                                New Arrivals
                            </h2>
                            <p className="text-gray-400 text-sm">
                                Best way to save more
                            </p>
                        </div>

                        {/* 🔹 ARROWS */}
                        <div className="hidden sm:flex gap-3">
                            <button className="w-12 h-12 rounded-full bg-[#187685] flex items-center justify-center text-white">
                                <ChevronLeft />
                            </button>
                            <button className="w-12 h-12 rounded-full bg-[#187685] flex items-center justify-center text-white">
                                <ChevronRight />
                            </button>
                        </div>
                    </div>

                    {/* 🔹 IMAGE ROW */}
                    <div className="flex gap-4 overflow-x-auto no-scrollbar sm:justify-between">
                        {images.map((img, index) => (
                            <div
                                key={index}
                                className="
                flex-shrink-0
                w-[155px]
                h-[206px]
                rounded-xl
                bg-white
                flex
                items-center
                justify-center
              "
                            >
                                <img
                                    src={img}
                                    alt={`img-${index}`}
                                    className="w-full h-full object-contain"
                                />
                            </div>
                        ))}
                    </div>

                </div>
            </div>
            {/* <Product_slider />
            <ExclusiveStore /> */}
        </>);
};

export default Six_slider;
